'use client'

import { Box, Stack, Typography } from "@mui/material";
import React from "react";

type _props = {
    title: string,
    description: string,
    image?: React.ReactNode,
    second_title?: string
};

export default function PaymentTitleCard({ title, description, image, second_title }: _props) {

    return <Box
        style={{ background: 'linear-gradient(95deg, rgba(61, 204, 156, 0.30) 0%, rgba(102, 135, 255, 0.30) 52.08%, rgba(255, 222, 192, 0.30) 100%)' }}
        className="__PaymentTitleCard__ rounded-xl py-10 lg:px-[70px] px-6 text-darkText w-full flex lg:flex-row flex-col justify-between items-center"
    >
        <Stack
            useFlexGap
            direction={'column'}
            className={'__Stack_1__'}
        >
            <Stack
                direction={'row'}
                alignItems={'center'}
                spacing={0.5}
                className={'__Stack_2__ subtitle'}
            >
                <h3>{title}</h3>
            </Stack>

            <Typography
                fontSize={34}
                fontWeight={700}
                className={'__Stack_3__ title'}
            >
                {description}
            </Typography>

        </Stack>

        {image &&
            image
        }
    </Box>
}

